import { useMemo } from 'react';

interface Slice {
  data: any[],
  more:number
}

const useArraySlice = (data:any[], limit:number):Slice => useMemo(() => {
  const defaultSlice: Slice = {
    data: [],
    more: 0,
  };

  if (Array.isArray(data) && data.length) {
    if (data.length > limit) {
      defaultSlice.data = data.slice(0, limit);
      defaultSlice.more = data.length - limit;
    } else {
      defaultSlice.data = data;
      defaultSlice.more = 0;
    }
  }

  return defaultSlice;
}, [data, limit]);

export default useArraySlice;
